module.exports = __webpack_public_path__ + "static/media/keyposer-200-133.e70cb882.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/layout/assets/keyposer-200-133.jpg
// module id = 88
// module chunks = 0